import produce from 'immer';
import _get from 'lodash/get';

import initialState from '../initialState/session';
import * as sessionActionTypes from '../../constants/actionTypes/session';
import { UPDATE_CONNECTED_CLIENTS, SET_CONNECTED } from '../../constants/actionTypes/sockets';

// eslint-disable-next-line no-unused-vars
const session = (state = initialState, action) =>
    produce(state, (draftState) => {
        const {
            authorization,
            integration,
            features,
            collaboration,
            controls,
            userData,
            users,
            currentUserSocketId,
            isConnected,
        } = action.payload || {};
        switch (action.type) {
            case SET_CONNECTED:
                draftState.collaboration.isConnected = isConnected;
                break;
            case UPDATE_CONNECTED_CLIENTS:
                draftState.collaboration.connectedClients = users;
                draftState.collaboration.currentUserSocketId = currentUserSocketId;
                break;
            case sessionActionTypes.UPDATE_AUTHORIZATION:
                draftState.authorization = authorization;
                break;
            case sessionActionTypes.SET_LOADING:
                draftState.loading = action.payload;
                break;
            case sessionActionTypes.SET_SESSION:
                return {
                    ...draftState,
                    authorization: authorization || initialState.authorization,
                    integration: integration || initialState.integration,
                    features: features || initialState.features,
                    collaboration: collaboration || initialState.collaboration,
                    controls: controls || initialState.controls,
                    user: {
                        firstName: userData.firstName || 'N/A',
                        lastName: userData.lastName || 'N/A',
                        email: userData.email || 'N/A',
                        userID: userData.userID || 'N/A',
                        accountID: userData.accountID || 'N/A',
                        parentID: userData.parentID || 'N/A',
                        groupID: userData.groupID || 'N/A',
                        plan: userData.plan || 'N/A',
                        permission: userData.permission || 'N/A',
                        isAdminOrParentAdmin: userData.permission === 'PARENT_ADMIN' || userData.permission === 'ADMIN',
                        // setting default as true since we will hide features behind this flag if integrations are enabled
                        // this will be only set as false if it is an explicit boolean false coming from user data
                        isIntegrationsEnabled:
                            !!userData.isIntegrationsEnabled ||
                            userData.isIntegrationsEnabled === null ||
                            userData.isIntegrationsEnabled === undefined,
                        ipAddress: userData.ipAddress || 'N/A',
                        features: {
                            EMAIL_DESIGNER_CUSTOM_FONTS: _get(userData, 'features.EMAIL_DESIGNER_CUSTOM_FONTS', false),
                            EMAIL_DESIGNER_VERSION_HISTORY: _get(
                                userData,
                                'features.EMAIL_DESIGNER_VERSION_HISTORY',
                                false
                            ),
                            EMAIL_DESIGNER_STYLING_ACCESS: _get(
                                userData,
                                'features.EMAIL_DESIGNER_STYLING_ACCESS',
                                true
                            ),
                            EMAIL_DESIGNER_CUSTOMIZATION: _get(
                                userData,
                                'features.EMAIL_DESIGNER_CUSTOMIZATION',
                                false
                            ),
                            EMAIL_DESIGNER_RAW_IMAGE_UPLOA: _get(
                                userData,
                                'features.EMAIL_DESIGNER_RAW_IMAGE_UPLOA',
                                false
                            ),
                            EMAIL_DESIGNER_PERSONALIZATION: _get(
                                userData,
                                'features.EMAIL_DESIGNER_PERSONALIZATION',
                                false
                            ),
                            SURVEY_SOCIAL_REACTIONS: _get(userData, 'features.SURVEY_SOCIAL_REACTIONS', false),
                            SURVEY_ENPS: _get(userData, 'features.SURVEY_ENPS', false),
                            SURVEYS_PULSE_CUSTOM: _get(userData, 'features.SURVEYS_PULSE_CUSTOM', false),
                            SURVEYS_PULSE_PRESET: _get(userData, 'features.SURVEYS_PULSE_PRESET', false),
                            CONTENT_LIBRARY_ACCESS: _get(userData, 'features.CONTENT_LIBRARY_ACCESS', false),
                        },
                        customization: {
                            colors: _get(userData, 'customization.colors', initialState.user.customization.colors),
                            primaryFont: _get(
                                userData,
                                'customization.primaryFont',
                                initialState.user.customization.primaryFont
                            ),
                            secondaryFont: _get(
                                userData,
                                'customization.secondaryFont',
                                initialState.user.customization.secondaryFont
                            ),
                            linkDecoration: _get(
                                userData,
                                'customization.linkDecoration',
                                initialState.user.customization.linkDecoration
                            ),
                            linkColor: _get(
                                userData,
                                'customization.linkColor',
                                initialState.user.customization.linkColor
                            ),
                            textStyles: {
                                headerParagraph: _get(
                                    userData,
                                    'customization.textStyles.headerParagraph',
                                    initialState.user.customization.textStyles.headerParagraph
                                ),
                                headerOne: _get(
                                    userData,
                                    'customization.textStyles.headerOne',
                                    initialState.user.customization.textStyles.headerOne
                                ),
                                headerTwo: _get(
                                    userData,
                                    'customization.textStyles.headerTwo',
                                    initialState.user.customization.textStyles.headerTwo
                                ),
                                headerThree: _get(
                                    userData,
                                    'customization.textStyles.headerThree',
                                    initialState.user.customization.textStyles.headerThree
                                ),
                            },
                        },
                    },
                };
            default:
                return state;
        }
    });

export default session;
